import Loader from "../components/loader/Loader";

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <Loader/>
  </div>
);

export default PageLoader;